export default __webpack_public_path__ + "static/media/pokedex.3dce33dc.png";